import { SafeEnv } from 'SharedDir/utils/helpers';

type TSentryConfig = {
  environment: string;
  trackComponents: boolean;
  dsn: string;
  tracesSampleRate: number;
};

export const SENTRY_OPTIONS: TSentryConfig = {
  environment: SafeEnv(() => process.env.SENTRY_ENVIRONMENT) ?? 'LOCAL_*',
  trackComponents: SafeEnv(() => process.env.SENTRY_TRACK_COMPONENTS) === 'true',
  dsn: SafeEnv(() => process.env.SENTRY_DSN) ?? '',
  tracesSampleRate: Number(SafeEnv(() => process.env.SENTRY_SAMPLE_RATE) ?? 0),
};
